import React, { useState, useEffect, useRef } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  FormControl,
  ListItemText,
  Card,
} from "@mui/material";
import axios from "axios";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledCheckbox,
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledDatePicker,
  OutlinedIconFab,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { durationType } from "../initialData/initialData";
import { getHumanReadableDiffInPastDate } from "../Utils/UtilsFunctions";
import Icon from "../Utils/Icons";
const DrugHistory = ({
  drugHistoryData,
  setDrugHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Drug History called", drugHistoryData);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalled, setDebounceFunctionCalled] = useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const startListening = (key) => {
    setActiveHistorySection("Drug History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
    if (key == "condition") {
      setClinicalNotesListening(false);
    } else {
      setClinicalNotesListening(true);
    }
  };
  const today = dayjs();
  const [drugType, setDrugType] = useState({
    branded: true,
    generic: true,
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [drugName, setDrugName] = useState("");
  const [drugVars, setDrugVars] = useState({
    drug_description: "",
    drug_name: "",
    onset_datetime: null,
    abatement_datetime: null,
    clinical_note: "",
    duration: "",
    durationType: "days",
  });
  const [drugEditIndex, setDrugEditIndex] = useState(null);
  const [drugError, setDrugError] = useState("");
  const [clinicalNotesListening, setClinicalNotesListening] = useState(false);
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  useEffect(() => {
    // alert(`DH ${activeHistorySection}`);
    if (activeHistorySection == "Drug History") {
      let timerId;

      timerId = setTimeout(() => {
        setDrugName(transcript);
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);

  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when drugName changes

    let timerOut = setTimeout(() => {
      if (drugName.trim() !== "") {
        debouncedMedicineFilterCall(drugName.toLowerCase());
      }
    }, 1000);
    return () => clearInterval(timerOut);
  }, [drugName]);
  const handleAddDrugRow = async () => {
    if (drugVars.drug_name || drugName.length > 0) {
      // Store the updated state in a local variable

      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        let semanticTagForMedicineSearch =
          drugType.branded && drugType.generic
            ? "real clinical drug++clinical drug"
            : drugType.branded
            ? "real clinical drug"
            : drugType.generic
            ? "clinical drug"
            : "";
        const postBody = {
          term: drugName,
          state: "active",
          semantictag: semanticTagForMedicineSearch,
          acceptability: "synonyms",
          returnlimit: "-1",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (drugName.length > 2) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find((d) => d.term === drugName);
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: drugName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: drugName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: drugName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: drugName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...drugVars,
                  drug_name: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...drugVars,
                  drug_name: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...drugVars,
                drug_name: drugName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...drugVars,
            drug_name: drugName,
            id: null,
          };
        }
      } else {
        newDetails = { ...drugVars };
      }

      const newRow = {
        drug_description: newDetails.drug_description,
        drug_name: newDetails.drug_name,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),
        abatement_datetime:
          newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        clinical_note: newDetails?.clinical_note,
        duration: newDetails?.duration,
        durationType: newDetails?.durationType,
      };

      // Update family history rows by adding the new row

      const updatedRows = [...drugHistoryData["new"], newRow];

      setDrugHistoryData({
        ...drugHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setDrugVars({
        drug_description: "",
        drug_name: "",
        onset_datetime: null,
        abatement_datetime: null,
        clinical_note: "",
        duration: "",
        durationType: "days",
      });
      setDrugError("");
      setDrugName("");
      setSuggestApiCalled(false);
      setDebounceFunctionCalled(false);
      setTermSelectedOrAdded(false);
      optionChosen.current = false;
      setFilteredOptions([]);
    } else {
      // Set error message if any field is missing
      setDrugError("Drug Name field is required");
    }
  };
  const handleDrugEditClick = (row, rowIndex) => {
    console.log("Drug Edit Click", row);
    setDrugName(row.drug_name);
    setDrugVars({
      drug_description: row.drug_description,
      drug_name: "",
      onset_datetime: row.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row.abatement_datetime
        ? dayjs(row.abatement_datetime)
        : null,
      clinical_note: row?.clinical_note,
      duration: row?.duration,
      durationType: row?.durationType,
    });

    setDrugEditIndex(rowIndex);
  };
  console.log("Drug Edit Index", drugEditIndex, drugName, drugVars.drug_name);
  const handleDrugUpdate = async () => {
    if (drugVars.drug_name || drugName.length > 0) {
      // Store the updated state in a local variable

      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        let semanticTagForMedicineSearch =
          drugType.branded && drugType.generic
            ? "real clinical drug++clinical drug"
            : drugType.branded
            ? "real clinical drug"
            : drugType.generic
            ? "clinical drug"
            : "";
        const postBody = {
          term: drugName,
          state: "active",
          semantictag: semanticTagForMedicineSearch,
          acceptability: "synonyms",
          returnlimit: "-1",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (drugName.length > 2) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find((d) => d.term === drugName);
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: drugName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: drugName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: drugName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: drugName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...drugVars,
                  drug_name: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...drugVars,
                  drug_name: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...drugVars,
                drug_name: drugName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...drugVars,
            drug_name: drugName,
            id: null,
          };
        }
      } else {
        newDetails = { ...drugVars };
      }

      const updatedRow = {
        drug_description: newDetails.drug_description,
        drug_name: newDetails.drug_name,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),
        abatement_datetime:
          newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        clinical_note: newDetails?.clinical_note,
        duration: newDetails?.duration,
        durationType: newDetails?.durationType,
        source: undefined,
      };
      const updatedDrug = drugHistoryData["new"].map((row, index) => {
        if (index === drugEditIndex) {
          return updatedRow;
        } else {
          return row;
        }
      });
      setDrugHistoryData({
        ...drugHistoryData,
        new: updatedDrug,
      });
      // Reset family history variables and clear error
      setDrugVars({
        drug_description: "",
        drug_name: "",
        onset_datetime: null,
        abatement_datetime: null,
        clinical_note: "",
        duration: "",
        durationType: "days",
      });
      setDrugEditIndex(null);
      setDrugName("");
      setDrugError("");
      setSuggestApiCalled(false);
      setDebounceFunctionCalled(false);
      setTermSelectedOrAdded(false);
      setFilteredOptions([]);
      optionChosen.current = false;
    } else {
      // Set error message if any field is missing
      setDrugError("Drug Name field is required");
    }
  };
  const handleDrugDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedDrug = drugHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setDrugHistoryData({
      ...drugHistoryData,
      new: updatedDrug,
    });
  };
  // const handleChangeDrug = (field, value) => {
  //   if (field === "drug_name") {
  //     setAutoCompleteData([]);
  //     setFilteredOptions([]);
  //     setTermSelectedOrAdded(true);
  //   }
  //   setDrugVars({
  //     ...drugVars,
  //     [field]: value, // Use computed property name to set the field dynamically
  //   });
  // };
  const handleChangeDrug = (field, value) => {
    if (field === "drug_name") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
    }

    let updatedDetails = { ...drugVars, [field]: value };

    // If field is duration or durationType, calculate onset date using helper
    if (
      (field === "duration" || field === "durationType") &&
      updatedDetails.duration &&
      updatedDetails.durationType
    ) {
      const calculatedDate = calculateOnsetDate(
        parseInt(updatedDetails.duration),
        updatedDetails.durationType
      );

      updatedDetails.onset_datetime = calculatedDate ?? null;
    } else if (field === "duration" || field === "durationType") {
      updatedDetails.onset_datetime = null;
    }

    setDrugVars(updatedDetails);
  };
  const calculateOnsetDate = (duration, type) => {
    if (!duration) return null;
    const today = dayjs(); // Current date
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    console.log("date onset", today.subtract(duration, durationMap[type]));
    return today.subtract(duration, durationMap[type]);
  };

  console.log("Drug Vars Details", drugVars);
  const handleDrugType = (type) => {
    setDrugType((prevDrugType) => ({
      ...prevDrugType,
      [type]: !prevDrugType[type],
    }));
  };
  const handleClearMedicineName = () => {
    setDrugError("");
    setDrugName("");
    resetTranscript();
    setDrugVars({
      ...drugVars,
      drug_name: "", // Use computed property name to set the field dynamically
    });
    setTermSelectedOrAdded(false);
    setFilteredOptions([]);
    setDebounceFunctionCalled(false);
    // setMedicineList([])
  };

  const debouncedMedicineFilterCall = async (medicine) => {
    let semanticTagForMedicineSearch =
      drugType.branded && drugType.generic
        ? "real clinical drug++clinical drug"
        : drugType.branded
        ? "real clinical drug"
        : drugType.generic
        ? "clinical drug"
        : "";
    const postBodyForMedicine = {
      term: medicine,
      state: "active",
      semantictag: semanticTagForMedicineSearch,
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (drugName.length > 2) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBodyForMedicine,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((medicineItem) => {
              let modifiedTerm = medicineItem.term;

              if (medicineItem.conceptFsn.includes("(real clinical drug)")) {
                // Extract the first parentheses content (ingredient like paracetamol)
                const matches = medicineItem.conceptFsn.match(/\(([^)]+)\)/);
                if (matches && matches[1]) {
                  const ingredient = matches[1].trim();
                  modifiedTerm = `${medicineItem.term} (${ingredient})`;
                }
              }
              return {
                term: modifiedTerm,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              if (drugName.length > 2) {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBodyForMedicine,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);

                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;

                    setAutoCompleteData(dataToProcess);
                    setFilteredOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredOptions([]);
                  }
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalled(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  }; // Adjust the debounce duration (in milliseconds) as needed
  const handleAddOption = async (term) => {
    let semanticTagForMedicineSearch =
      drugType.branded && drugType.generic
        ? "real clinical drug++clinical drug"
        : drugType.branded
        ? "real clinical drug"
        : drugType.generic
        ? "clinical drug"
        : "";
    const postBody = {
      term: term,
      state: "active",
      semantictag: semanticTagForMedicineSearch,
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (drugName.length > 2) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          let updatedFound = {},
            updatedSelectedOptiondetsils = {},
            foundData = false;
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            foundData = response.data.data.find((d) => d.term === term);
            console.log("Found Data", foundData);
            if (foundData) {
              updatedFound = {
                ...foundData,
                found: true,
                id: foundData.conceptId,
              };
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: term,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: term,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }
          } else {
            updatedSelectedOptiondetsils = {
              hierarchy: null,
              isPreferredTerm: null,
              conceptState: null,
              conceptFsn: term,
              definitionStatus: null,
              conceptId: null,
              languageCode: "en",
              typeId: null,
              term: term,
              caseSignificanceId: "CASE_INSENSITIVE",
              id: null,
              effectiveTime: null,
              activeStatus: null,
              moduleId: null,
            };
          }

          setAutoCompleteData([]);
          setFilteredOptions([]);
          setSuggestApiCalled(false);
          setDebounceFunctionCalled(true);
          if (foundData) {
            handleChangeDrug("drug_name", updatedFound.term);
          } else {
            handleChangeDrug("drug_name", updatedSelectedOptiondetsils.term);
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const handleClearClinicalNotes = () => {
    setDrugError("");

    resetTranscript();
    setDrugVars({
      ...drugVars,
      clinical_note: "", // Use computed property name to set the field dynamically
    });
  };

  const handleConditionTyped = (value) => {
    setDrugName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  console.log("Filtered Options Drug History", filteredOptions);
  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "0 4px 4px 0 #C7C7CC inset",
        backgroundColor: "#FFF",
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <MenuItem key="generic" onClick={() => handleDrugType("generic")}>
          <StyledCheckbox checked={drugType.generic} />
          <ListItemText primary="Generic" />
        </MenuItem>
        <MenuItem key="branded" onClick={() => handleDrugType("branded")}>
          <StyledCheckbox checked={drugType.branded} />
          <ListItemText primary="Branded" />
        </MenuItem>
      </div>
      <Grid
        container
        spacing={2}
        sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}
      >
        <Grid item xs={11} sm={11} md={11} sx={{ margin: "5px 0px" }}>
          <StyledTextField
            label="Drug Name"
            variant="outlined"
            value={
              // drugVars.drug_name !== "" ? drugVars.drug_name :
              drugName
            }
            onChange={(e) => {
              // if (!drugVars.drug_name) {
              //   setDrugName(e.target.value);
              // }
              handleConditionTyped(e.target.value);
            }}
            fullWidth
            onBlur={() => {
              setTimeout(() => {
                const shouldClear = !mouseDownOnOption;

                if (shouldClear) {
                  // setIsFocused(false);
                  setFilteredOptions([]);
                  setDebounceFunctionCalled(false);
                  setTermSelectedOrAdded(false);
                }

                setMouseDownOnOption(false);
              }, 100);
            }}
            onFocus={() => {
              // setIsFocused(true);
              if (drugName.trim() !== "") {
                debouncedMedicineFilterCall(drugName.toLowerCase()); // re-trigger filtering
              }
            }}
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearMedicineName}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>
                  {/* {!termSelectedOrAdded && (
                    <Tooltip title="Add" style={{ marginRight: "5px" }}>
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleAddOption}
                      >
                        <AddIcon />
                      </OutlinedIconFab>
                    </Tooltip>
                  )} */}
                  {/* <>
                    {listeningOn === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={startListening("condition")}
                          variant="contained"
                          color="defaultColor"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Stop Listening">
                        <OutlinedIconFab
                          onClick={() => {
                            SpeechRecognition.stopListening();
                            setListeningOn(false);
                          }}
                          variant="outlined"
                          color="defaultColor"
                          size="small"
                        >
                          <KeyboardVoiceIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    )}
                  </> */}
                  <>
                    {isAiEnabled &&
                      (listeningOn === false ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="defaultColor"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : listeningOn === true &&
                        clinicalNotesListening === true ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="default"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Stop Listening">
                          <OutlinedIconFab
                            onClick={() => {
                              // SpeechRecognition.stopListening();
                              stopRecording("Drug History");
                              setListeningOn(false);
                            }}
                            variant="outlined"
                            color="default"
                            size="small"
                          >
                            <Icon name="micInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ))}
                  </>
                </div>
              ),
            }}
          />
          {filteredOptions.length > 0 ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "200px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              {/* Display filtered medicines */}
              {suggestApiCalled && (
                <div style={{ color: "red" }}>
                  No Exact Matches found ! You can search for the following
                  Suggestions.
                </div>
              )}

              <>
                {filteredOptions.map((op) => (
                  <div key={op}>
                    {
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {op.added ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <StyledButton
                              color="success"
                              sx={{
                                textAlign: "left",
                                justifyContent: "flex-start",
                                width: "100%",
                              }}
                            >
                              {op.term}
                            </StyledButton>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "row",
                                color: "green",
                                fontStyle: "bold",
                              }}
                            >
                              <span>&#10003;</span>
                              <span>(Added)</span>
                            </div>
                          </div>
                        ) : (
                          <StyledButton
                            color="grey"
                            sx={{
                              textAlign: "left",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                            onClick={() => {
                              skipEffect.current = true; // prevent debounce call
                              optionChosen.current = true;
                              setDrugName(op.term);
                              handleChangeDrug("drug_name", op.term);
                            }}
                            onMouseDown={() => setMouseDownOnOption(true)}
                          >
                            {op.term}
                          </StyledButton>
                        )}
                      </div>
                    }
                  </div>
                ))}
              </>
            </div>
          ) : filteredOptions.length == 0 &&
            debounceFunctionCalled &&
            !termSelectedOrAdded ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "300px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              <div style={{ color: "red" }}>No Options Found!</div>
            </div>
          ) : null}
        </Grid>

        <Grid item xs={11} md={11} sm={11}>
          <StyledMultilineTextField
            id="outlined-multiline-static"
            label="Clinical Notes"
            multiline
            rows={2}
            value={drugVars.clinical_note}
            onChange={(e) => handleChangeDrug("clinical_note", e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearClinicalNotes}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>

                  <>
                    {/* {listeningOn === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="defaultColor"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : listeningOn === true &&
                      clinicalNotesListening === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="default"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Stop Listening">
                        <OutlinedIconFab
                          onClick={() => {
                            SpeechRecognition.stopListening();
                            setListeningOn(false);
                            setClinicalNotesListening(false);
                          }}
                          variant="outlined"
                          color="default"
                          size="small"
                        >
                          <KeyboardVoiceIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    )} */}
                  </>
                </div>
              ),
            }}
          />
        </Grid>

        {/* <Grid item xs={11} md={11} sm={11} sx={{ margin: "5px 0px" }}>
          <StyledMultilineTextField
            id="outlined-multiline-static"
            label="Description"
            multiline
            rows={2}
            value={drugVars.drug_description}
            onChange={(e) =>
              handleChangeDrug("drug_description", e.target.value)
            }
            fullWidth
          />
        </Grid> */}

        <Grid item xs={6} sm={2} md={2}>
          <StyledTextField
            label="Duration"
            fullWidth
            type="number"
            value={drugVars.duration || ""}
            // error={!!validationErrors.duration}
            // helperText={validationErrors.duration}
            onChange={(e) => handleChangeDrug("duration", e.target.value)}
            onWheel={(e) => e.target.blur()} // Prevent scroll change
            InputProps={{
              inputProps: {
                style: {
                  // Hide arrows in Chrome, Safari, Edge
                  MozAppearance: "textfield",
                },
              },
              sx: {
                // Hide arrows in Firefox
                "& input[type=number]": {
                  MozAppearance: "textfield",
                },
                // Hide arrows in Chrome, Safari, Edge
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                  {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
              },
            }}
          />
        </Grid>

        <Grid item xs={6} sm={3} md={3}>
          <StyledTextField
            select
            fullWidth
            label="Duration Type"
            value={drugVars.durationType || "days"}
            onChange={(e) => handleChangeDrug("durationType", e.target.value)}
          >
            {durationType.map((type) => (
              <MenuItem
                key={type.value}
                value={type.value}
                sx={{ fontSize: "12px" }}
              >
                {type.display}
              </MenuItem>
            ))}
          </StyledTextField>
        </Grid>

        <Grid item xs={11} md={3} sx={{ margin: "5px 0px", display: "none" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <StyledDatePicker
                label="Date Asserted"
                onChange={(date) => handleChangeDrug("onset_datetime", date)}
                slotProps={{
                  field: { clearable: true },
                }}
                maxDate={today}
                value={
                  drugVars?.onset_datetime
                    ? dayjs(drugVars?.onset_datetime)
                    : null
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
        {/* <Grid item xs={12} md={3} sx={{ margin: "5px 0px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <StyledDatePicker
                fullWidth
                label="End Date"
                onChange={(date) =>
                  handleChangeDrug("abatement_datetime", date)
                }
                slotProps={{
                  field: { clearable: true },
                }}
                maxDate={today}
                minDate={dayjs(drugVars.onset_datetime)}
                value={
                  drugVars?.abatement_datetime
                    ? dayjs(drugVars?.abatement_datetime)
                    : null
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid> */}
        <Grid
          item
          xs={11}
          sm={2}
          sx={{
            margin: "5px 0px",
            display: "flex",
            justifyContent: "flex-end",
            padding: "0px",
          }}
        >
          <StyledButton
            bgColor="#0E3F66"
            variant="contained"
            fullWidth
            onClick={
              drugEditIndex !== null ? handleDrugUpdate : handleAddDrugRow
            }
            color="defaultColor"
          >
            {drugEditIndex !== null ? "Update" : "Add"}
          </StyledButton>
        </Grid>
        <Grid item xs={11} md={11} sm={11}>
          {drugError && (
            <Typography style={{ color: "red" }}>{drugError}</Typography>
          )}
        </Grid>
        <Grid item xs={11} sm={11}>
          {drugHistoryData["prev"].length > 0 && (
            <StyledTableContainer
              component={Paper}
              // sx={{
              //   marginTop: "20px",
              //   border: "1px solid #21cdc0",
              // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Drug Name</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>Duration</StyledTableCellHistory>
                    {/* <StyledTableCellHistory>End Date</StyledTableCellHistory> */}
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {drugHistoryData["prev"].map((row, rowIndex) => {
                    // console.log("Drug Row", row); // Logging the row object

                    return (
                      <StyledTableRowHistory key={rowIndex}>
                        <StyledTableCellHistory>
                          {row?.drug_name}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {row?.clinical_note || "-"}
                        </StyledTableCellHistory>

                        <StyledTableCellHistory>
                          {row?.onset_datetime
                            ? getHumanReadableDiffInPastDate(
                                row?.onset_datetime
                              )
                            : "-"}
                        </StyledTableCellHistory>
                        {/* <StyledTableCellHistory>
                          {row?.abatement_datetime ?? "-"}
                        </StyledTableCellHistory> */}
                        <StyledTableCellHistory>-</StyledTableCellHistory>
                      </StyledTableRowHistory>
                    );
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>

        <Grid item xs={11} sm={11}>
          {drugHistoryData["new"].length > 0 && (
            <StyledTableContainer
              component={Paper}
              // sx={{
              //   marginTop: "20px",
              //   border: "1px solid #21cdc0",
              // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Drug Name</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>Duration</StyledTableCellHistory>
                    {/* <StyledTableCellHistory>End Date</StyledTableCellHistory> */}
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {drugHistoryData["new"].map((row, rowIndex) => {
                    console.log("Drug Row", row); // Logging the row object

                    return (
                      <StyledTableRowHistory key={rowIndex}>
                        <StyledTableCellHistory>
                          {row?.drug_name}
                          {row?.source === "voice" && !row.id && (
                            <Tooltip title="Machine-interpreted text — please verify before confirming">
                              <span className="missing-id-warning">⚠️</span>
                            </Tooltip>
                          )}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {row?.clinical_note || "-"}
                        </StyledTableCellHistory>

                        <StyledTableCellHistory>
                          {row?.duration
                            ? `${row?.duration} ${row?.durationType}`
                            : "-"}
                        </StyledTableCellHistory>
                        {/* <StyledTableCellHistory>
                          {row?.abatement_datetime ?? "-"}
                        </StyledTableCellHistory> */}
                        <StyledTableCellHistory>
                          {drugHistoryData["prev"].includes(row) ? (
                            "-"
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Tooltip title="Edit">
                                <OutlinedIconFab
                                  onClick={() =>
                                    handleDrugEditClick(row, rowIndex)
                                  }
                                  sx={{ marginRight: 1 }}
                                >
                                  <Icon name="editInTable" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <OutlinedIconFab
                                  onClick={() => handleDrugDelete(rowIndex)}
                                >
                                  <Icon name="deleteInTable" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            </div>
                          )}
                        </StyledTableCellHistory>
                      </StyledTableRowHistory>
                    );
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default React.memo(DrugHistory);
